export const createHoverMedia = (): MediaQueryList | null => {
  const hoverMedia = window?.matchMedia?.('(hover: hover)');

  if (!hoverMedia) {
    return null;
  }

  return hoverMedia;
};

export const checkIfHasHover = (): boolean => {
  const hoverMedia = createHoverMedia();

  if (hoverMedia === null) {
    // Вероятнее всего такое может произойти в старых
    // десктопных браузерах, поэтому возвращаем true
    return true;
  }

  return hoverMedia.matches;
};
